export default __webpack_public_path__ + "static/media/main-category-wellness.3aa510d0.jpg";